const shouldLog = () => {
  const isProdBuild = import.meta.env.PROD;
  const appEnvironment = import.meta.env.VITE_APP_ENVIRONMENT || "development";
  const isProdEnvironment =
    appEnvironment === "production" || import.meta.env.VITE_ENV === "prod";

  return !(isProdBuild && isProdEnvironment);
};

const log = (method: "log" | "info", data: unknown) => {
  if (!shouldLog()) return;
  console[method](data);
};

export const debugLog = (data: unknown) => {
  log("log", data);
};

export const debugInfo = (data: unknown) => {
  log("info", data);
};
